module.exports = __webpack_public_path__ + "media/images/emblems/Schlatt-blazon-5f4eaa47b99f705d02404926285cb67a.svg";